export default "__VITE_ASSET__squ$1HOJ__"